var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-btn",on:{"click":_vm.handleCopy}},[_c('im-icon',{attrs:{"icon":"icon-copy"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }